import { fetchAllJsonCached } from '../../fetch-all-json';

export function selectBiasData (allData, graphtype, platformname) {
  const platforms = allData?.[graphtype]?.platform_bias || {};
  const aliases = platformname === 'yahoo' ? ['yahoo', 'www.yahoo.com', 'search.yahoo.com', 'ca.search.yahoo.com'] : [platformname];
  const key = aliases.find(name => Array.isArray(platforms[name]) && platforms[name].length > 0);
  const data = key ? platforms[key].map(row => ({ ...row })) : [];
  const ratings = allData?.bias_ratings?.platform_bias || {};
  const recent = aliases.map(name => ratings[name]).find(Boolean);
  const timestamp = Date.parse(recent?.updated);
  const latest = Math.max(-Infinity, ...data.map(row => Date.parse(row.summary_date || row.record_date)).filter(Number.isFinite));
  if (typeof recent?.second_rating === 'number' && Number.isFinite(recent.second_rating) && Number.isFinite(timestamp) && timestamp > latest) {
    data.push({ bias_score: recent.second_rating, record_date: recent.updated, summary_date: recent.updated });
  }
  return data;
}

export async function fetchBiasData (graphtype, platformname) {
  return selectBiasData(await fetchAllJsonCached(), graphtype, platformname);
}

export async function fetchVoteBiasData (graphtype, platformName) {
  const allData = await fetchAllJsonCached();

  if (!allData) {
    console.error('Failed to fetch vote bias data - API returned no data');
    return [];
  }

  const platforms = allData.go_vote_metrics;

  if (!platforms || !platforms[platformName]) {
    console.error(`No vote metrics found for platform: ${platformName}`);
    return [];
  }

  const data = platforms[platformName][graphtype];

  if (!data) {
    console.error(`No vote data found for platform: ${platformName} in graph type: ${graphtype}`);
    return [];
  }

  return data;
}
